import { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { HasAccess } from "common/utils/accessUtils";
import {
  Grid,
  GridItem,
  Text,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  useDisclosure,
  Flex,
  Box,
  Image,
} from "@chakra-ui/react";
import { DeleteIcon, ViewIcon, EditIcon } from "@chakra-ui/icons";
import { CiMenuKebab } from "react-icons/ci";
import { getApi } from "common/services/api";
import CommonCheckTable from "common/components/checktable";
import Add from "./add";
import Edit from "./Edit";
import Spinner from "common/components/spinner/Spinner";
import CommonDeleteModel from "common/components/commonDeleteModel";
import { deleteManyApi } from "common/services/api";
import { capitalizeFirstLetter } from "services/Crm/utils/calcUtils";
import { singularizeLastWord } from "services/Crm/utils/calcUtils";
import { pluralizeLastWord } from "services/Crm/utils/calcUtils";
import editIcon from "common/assets/img/editIcon.png";
import deleteIcon from "common/assets/img/deleteIcon.png";
import { constant } from "common/constant";
import { crmConstant } from "services/Crm/constant";
import StatusDropdown from "../statusDropdown";
import { toast } from "react-toastify";
import { putApi } from "common/services/api";
import KanbanView from "../kanban";
import { formatedCurrency } from "common/utils/currencyUtils";

const Index = () => {
  const hash = window.location.hash; // Get the part after the hash (#/crm/leads)
  const path = hash.replace("#", "").split("/"); // Remove the '#' and get the path
  const title = path[2] ? path[2].replace(/-/g, " ") : "";
  const size = "lg";
  const location = useLocation();
  const user = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();
  const [permission] = HasAccess([title]);
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [kanbanData, setKanbanData] = useState([])
  const [kanbanColumn, setKanbanColumns] = useState([]);
  const [tableColumns, setTableColumns] = useState([]);
  const [columns, setColumns] = useState([]);
  const [dataColumn, setDataColumn] = useState([]);
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [action, setAction] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [menuSelectedDeleteItem, setMenuSelectedDeleteItem] = useState([]);
  const moduleDataRef = useRef(null);
  const [moduleData, setModuleData] = useState({});
  const [edit, setEdit] = useState(false);
  const [deleteModel, setDelete] = useState(false);
  const [selectedId, setSelectedId] = useState();
  const [selectedValues, setSelectedValues] = useState([]);
  const [isImport, setIsImport] = useState(false);
  const [listView, setListView] = useState(true);
  const [tableView, setTableView] = useState(false);
  const [viewMode, setViewMode] = useState("list");
  const [statusOptions, setStatusOptions] = useState([]);
  const [dealId, setDealId] = useState();

  const switchToListView = () => setViewMode("list");
  const switchToKanbanView = () => setViewMode("kanban");
  const [currentPage, setCurrentPage] = useState(() => {
    const paginationState = JSON.parse(localStorage.getItem("paginationState"));
    return paginationState?.pageName === title && paginationState?.currentPage
      ? paginationState.currentPage
      : 1;
  });
  const [pageSize, setPageSize] = useState(() => {
    const paginationState = JSON.parse(localStorage.getItem("paginationState"));
    return paginationState?.pageName === title && paginationState?.pageSize
      ? paginationState.pageSize
      : 10;
  });
  const [sortColumn, setSortColumn] = useState(null);
  const [sortOrder, setSortOrder] = useState("");
  const [metadata, setMetadata] = useState({});
  const [searchbox, setSearchbox] = useState(null);
  const [finalSearchedData, setFinalSearchedData] = useState(kanbanData || []);
  const moduleId = moduleDataRef.current?._id || moduleData?._id;
  const [singleDataId, setSingleDataId] = useState("");
  const [currentView, setCurrentView] = useState(constant.listView);
  const [viewPreferences, setViewPreferences] = useState(() => {
    const stored = localStorage.getItem("viewPreferences");
    try {
      return stored ? JSON.parse(stored) : {};
    } catch (error) {
      console.error("Failed to parse viewPreferences:", error);
      return {};
    }
  });

   useEffect(() => {
    document.body.classList.add("bgWhiteImp");
    return () => {
      document.body.classList.remove("bgWhiteImp");
    };
  }, []);

  useEffect(() => {
    if (viewPreferences?.deal === "list") {
      setTableView(false);
      setListView(true);
      setCurrentView(constant.listView);
    } else if (
      viewPreferences?.deal === "kanban" &&
      title === crmConstant.deals
    ) {
      setTableView(true);
      setListView(false);
      setCurrentView(constant.tableView);
    } else {
      setTableView(false);
      setListView(true);
      setCurrentView(constant.listView);
    }
  }, [viewPreferences, title]);

  function toCamelCase(str) {
    return str
      .toLowerCase()
      .split(" ")
      .map((word, index) =>
        index === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1)
      )
      .join("");
  }

  const fetchData = async (
    id = moduleId,
    page = currentPage,
    limit = pageSize,
    sortKey = sortColumn,
    order = sortOrder,
    searchTerm = "",
    fetchAllData = false,
  ) => {
    setIsLoading(true);
    let endpoint =
      user.role === "superAdmin"
        ? `api/form?moduleId=${id}&page=${page}&limit=${limit}`
        : `api/form?moduleId=${id}&createBy=${user._id}&page=${page}&limit=${limit}`;

    if (fetchAllData) {
      endpoint = user.role === "superAdmin"
        ? `api/form?moduleId=${id}&allData=true`
        : `api/form?moduleId=${id}&createBy=${user._id}&allData=true`;
    }
    if (sortKey) {
      const sortParam = order === "desc" ? `-${sortKey}` : sortKey;
      endpoint += `&sort=${sortParam}`;
    }

    if (searchTerm) {
      endpoint += `&search=${encodeURIComponent(searchTerm)}`;
    }

    try {
      const result = await getApi(endpoint);
      if (result.status === 200) {
        if (fetchAllData) {
          setKanbanData(result?.data?.data)
          if (currentView === constant.tableView) {
            setFinalSearchedData(result?.data?.data)
          }
        } else {
          setData(result?.data?.data)
          setMetadata(result?.data?.metadata);
        }
      }
    } catch (error) {
      console.error("Failed to fetch form data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const EditData = async (updatedRow) => {
    try {
      // setIsLoading(true);
      const idToEdit = updatedRow._id || selectedId;

      if (!idToEdit) throw new Error("Missing ID for editing");

      const response = await putApi(`api/form/edit/${idToEdit}`, {
        moduleId: moduleDataRef.current?._id,
        ...updatedRow,
      });

      if (response.status === 200) {
        toast.success("Updated successfully!");
        setEdit(false);
        setAction((prev) => !prev);
        if (moduleDataRef.current?._id) {
          fetchData(moduleDataRef.current?._id)
        }
      } else {
        toast.error("Failed to update data");
      }
    } catch (error) {
      console.error("Edit error:", error);
      toast.error(error.message || "Something went wrong while editing");
    } finally {
      // setIsLoading(false);
    }
  };

  const kanbanCardUpdateHandler = async (action, card) => {
    if (action === "update") {
      const updateData = kanbanData.find((item) => item._id === card.id);
      const cardStage = toCamelCase(card.stage);
      updateData.stage = cardStage;
      EditData(updateData);
    } else if (action === "delete") {
      console.log("card", card);
      try {
        const payload = {
          moduleId: moduleDataRef.current?._id,
          ids: Array.isArray(card) ? card : [card],
        };
        let response = await deleteManyApi("api/form/deleteMany", payload);
        if (response.status === 200) {
          setSelectedValues([]);
          toast.success("Deal deleted successfully!");
          if (currentView === constant.tableView) {
            fetchData(moduleId, 1, 10, sortColumn, sortOrder, searchbox, true)
          } else {
            fetchData(moduleId, currentPage, pageSize, sortColumn, sortOrder, searchbox, false)
          }
          setAction((pre) => !pre);
          return true;
        } else {
          return false;
        }
      } catch (error) {
        toast.error("Something went wrong");
        return false;
      } finally {
        setMenuSelectedDeleteItem([]);
        setDelete(false);
      }
    }
  };

  useEffect(() => {
    if (currentView === constant.listView) {
      if (moduleId) {
        fetchData(moduleId, currentPage, pageSize);
      }
    }
  }, [moduleId, currentPage]);

  const handlePageSizeChange = (newPageSize) => {
    if (newPageSize !== pageSize) {
      setPageSize(newPageSize);
      setCurrentPage(1);
      const paginationState = {
        pageName: title,
        currentPage: 1,
        pageSize: newPageSize,
      };
      localStorage.setItem("paginationState", JSON.stringify(paginationState));
    }
  };

  const fetchCustomDataFields = async () => {
    const result = await getApi(`api/custom-field/?moduleName=${title}`);
    const singaleData = result?.data?.find(
      (item) => item?.moduleName === title
    );
    const optionsData = result?.data[0].fields;
    const statusOrStageOptions = optionsData
      .filter(
        (field) =>
          (field.name.toLowerCase().includes("status") ||
            field.name.toLowerCase().includes("stage")) &&
          Array.isArray(field.options) &&
          field.options.length > 0
      )
      .map((field) => ({
        label: field.label,
        name: field.name,
        options: field.options,
      }));

    setStatusOptions(statusOrStageOptions);
    moduleDataRef.current = singaleData;
    setModuleData(singaleData);

    const actionHeader = {
      Header: crmConstant.action,
      isSortable: false,
      center: true,
      cell: ({ row }) => (
        <Box className="actionCellContainer">
          {permission?.update && (
            <Box className="toolTipBox">
              <Image
                onClick={() => {
                  navigate(
                    `/crm/${title || constant.defaultTitle}/${row?.values?._id
                    }`,
                    {
                      state: { isEdit: true, module: singaleData || {} },
                    }
                  );
                }}
                src={editIcon}
                h={"16px"}
                w={"16px"}
              />
              <Text className="toolTip">{constant.edit}</Text>
            </Box>
          )}
          {permission?.delete && (
            <Box className="toolTipBox">
              <Image
                onClick={() => {
                  setDelete(true);
                  setSelectedValues([row?.values?._id]);
                  setMenuSelectedDeleteItem([row?.values?._id]);
                }}
                src={deleteIcon}
                h={"16px"}
                w={"16px"}
              />
              <Text className="toolTip">{constant.delete}</Text>
            </Box>
          )}
        </Box>
      ),
    };

    const tempTableColumns = [
      { Header: "#", accessor: "_id", isSortable: false, width: 10 },
      ...(singaleData?.fields
        ?.filter((field) => field?.isTableField === true)
        ?.map((field) => ({
          Header: field?.label,
          accessor: field?.name,
          cell: (cell) => {
            const isStatusField = ["status", "stage"].some((keyword) =>
              cell.column.id?.toLowerCase().includes(keyword)
            );
            const isAmountField = cell?.column.id?.toLowerCase().includes("amount");
            setDealId(cell?.row?.original?._id);

            if (!isStatusField) {
              return (
                <div className="selectOpt">
                  <Text
                    onClick={() => {
                      navigate(`/crm/${title}/${cell?.row?.original?._id}`, {
                        state: { module: singaleData },
                      });
                    }}
                    me="10px"
                    sx={{
                      "&:hover": {
                        color: "blue.500",
                        textDecoration: "underline",
                      },
                      cursor: "pointer",
                    }}
                    color="brand.600"
                    fontSize="sm"
                    fontWeight="700"
                  >
                    {isAmountField
                      ? formatedCurrency(cell?.value)
                      : cell?.value || "-"
                    }
                  </Text>
                </div>
              );
            } else {
              return (
                <>
                  <StatusDropdown
                    changeHandler={(newStatus) => {
                      if (newStatus !== cell?.value) {
                        EditData({
                          ...cell.row.original,
                          [cell.column.id]: newStatus,
                        })
                      }
                    }
                    }
                    statusOptions={statusOrStageOptions[0].options}
                    initialStatus={cell?.value}
                    color="gray.100"
                  />
                </>
              );
            }
          },
        })) || []),
      ...(permission?.update || permission?.view || permission?.delete
        ? [actionHeader]
        : []),
    ];

    const dataKanban = [
      {
        Header: "#",
        accessor: "_id",
        isSortable: false,
        width: 10,
      },
      ...(singaleData?.fields
        ?.filter((field) =>
          ["dealName", "closeDate", "amount"].includes(field?.name)
        )
        ?.map((field) => ({
          Header: field?.label,
          accessor: field?.name,
        })) || []),
      {
        Header: "Action",
        isSortable: false,
        center: true,
      },
    ];

    setSelectedColumns(tempTableColumns);
    setColumns(tempTableColumns);
    setTableColumns(tempTableColumns);

    setKanbanColumns(dataKanban);
  };

  console.log("kanbanColumns in dynamic", kanbanColumn);
  const handleDelete = async (id, moduleId) => {
    try {
      const payload = {
        moduleId: moduleId,
        ids: id,
      };
      let response = await deleteManyApi("api/form/deleteMany", payload);
      if (response.status === 200) {
        setSelectedValues([]);
        const entityLabel =
          title === crmConstant.accounts
            ? selectedValues && selectedValues.length > 1
              ? crmConstant.accounts
              : crmConstant.accountSigular
            : title === crmConstant.deals
              ? selectedValues && selectedValues.length > 1
                ? crmConstant.deals
                : crmConstant.dealSingular
              : title;

        toast.success(`${entityLabel} ${crmConstant.deletedSuccessfully}`);
        if (currentView === constant.tableView) {
          fetchData(moduleId, 1, 10, sortColumn, sortOrder, searchbox, true)
        } else {
          fetchData(moduleId, currentPage, pageSize, sortColumn, sortOrder, searchbox, false)
        }
        setDelete(false);
        setAction((pre) => !pre);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setMenuSelectedDeleteItem([]);
    }
  };
  const handleSearchChange = (term) => {
    const pageToFetch = term?.trim() === "" ? currentPage : 1;
    if (currentView === constant.tableView) {
      fetchData(moduleId, pageToFetch, pageSize, sortColumn, sortOrder, term, true)
    } else {
      fetchData(moduleId, pageToFetch, pageSize, sortColumn, sortOrder, term, false)
    }
  };
  const handleSortChange = (accessorKey) => {
    let newSortOrder = "asc";

    if (sortColumn === accessorKey) {
      newSortOrder = sortOrder === "asc" ? "desc" : "asc";
    }

    setSortColumn(accessorKey);
    setSortOrder(newSortOrder);

    fetchData(moduleId, currentPage, pageSize, accessorKey, newSortOrder);
  };

  // useEffect(() => {
  //   setListView(true);
  //   setTableView(false);
  // }, [location]);

  const updateViewPreference = async (newView) => {
    try {
      setIsLoading(true);
      const _id = JSON.parse(localStorage.getItem("user"))?._id;

      const updatedPreferences = {
        ...viewPreferences,
        deal: newView,
      };

      const values = {
        viewPreferences: updatedPreferences,
      };

      const response = await putApi(`api/user/edit/${_id}`, values);

      if (response.status === 200) {
        localStorage.setItem(
          "viewPreferences",
          JSON.stringify(updatedPreferences)
        );
        setViewPreferences(updatedPreferences);
        // toast.success(crmConstant.viewUpdateSuccessfully);
        if (newView === "list") {
          setCurrentView(constant.listView);
        } else if (newView === "kanban") {
          setCurrentView(constant.tableView);
        }
      }
    } catch (err) {
      toast.error(crmConstant.failedToUpdateViewPreference);
    } finally {
      setIsLoading(false);
    }
  };

  const handleListView = () => {
    if (viewPreferences?.deal === "list") return;
    updateViewPreference("list");
  };

  const handleTableView = () => {
    if (viewPreferences?.deal === "kanban") return;
    if (title === crmConstant.deals) {
      updateViewPreference("kanban");
    }
  };

  // const handleViewChange = () => {

  // }

  // const tabActions = {
  //   list: handleListView,
  //   table: handleTableView,
  // };
  // const handleTabChange = (index) => {
  //   const tabKeys = Object.keys(tabActions);
  //   const action = tabActions[tabKeys[index]];
  //   if (action) action();
  // };

  useEffect(() => {
    setDataColumn(
      tableColumns?.filter((item) =>
        selectedColumns?.find((column) => column?.Header === item.Header)
      )
    );
  }, [tableColumns, selectedColumns]);

  useEffect(() => {
    setSelectedValues([]);
    setMenuSelectedDeleteItem([]);
    fetchCustomDataFields();
  }, [action, title, currentPage]);
  const onLinkClick = (id) => {
    return `/crm/${title}/${id}`;
  };
  function closeDeleteModal() {
    setDelete(false);
    setMenuSelectedDeleteItem([]);
  }
  useEffect(() => {
    if (moduleId) {
      if (currentView === constant.listView) {
        fetchData(moduleId, currentPage)
      }
    }
  }, [currentPage, currentView, moduleId])

  useEffect(() => {
    if (moduleId) {
      if (currentView === constant.tableView) {
        fetchData(moduleId, 1, 10, sortColumn, sortOrder, searchbox, true)
      } else {
        fetchData(moduleId, currentPage, pageSize, sortColumn, sortOrder, searchbox, false)
      }
    }
  }, [currentView, moduleId])
  return (
    <div>
      <Grid templateColumns="repeat(6, 1fr)" mb={3} gap={4}>
        {/* {!isLoading && ( */}
        <GridItem colSpan={6}>
          {listView && (
            <CommonCheckTable
              title={singularizeLastWord(title)}
              isLoading={isLoading}
              viewData={moduleData}
              columnData={columns}
              onLinkClick={onLinkClick}
              dataColumn={dataColumn}
              allData={data}
              tableData={data}
              tableCustomFields={
                data?.[0]?.fields?.filter(
                  (field) => field?.isTableField === true
                ) || []
              }
              access={permission}
              action={action}
              setAction={setAction}
              selectedColumns={selectedColumns}
              setSelectedColumns={setSelectedColumns}
              // handleTabChange={handleTabChange}
              isOpen={isOpen}
              onClose={onclose}
              onOpen={() =>
                navigate(`/crm/${title}/create`, {
                  state: { module: moduleData },
                })
              }
              selectedValues={selectedValues}
              setSelectedValues={setSelectedValues}
              setDelete={setDelete}
              setIsImport={setIsImport}
              listViewHandle={handleListView}
              kanbanViewHandle={handleTableView}
              currentView={currentView}
              setCurrentPage={setCurrentPage}
              currentPage={currentPage}
              fetchData={fetchData}
              pageSize={pageSize}
              setPageSize={setPageSize}
              metadata={metadata}
              sortOrder={sortOrder}
              handleSortChange={handleSortChange}
              handleSearchChange={handleSearchChange}
              searchbox={searchbox}
              setSearchbox={setSearchbox}
              isDynamic={true}
            />
          )}
        </GridItem>
        {/* )} */}
        {tableView && (
          <KanbanView
            kanbanCardUpdateHandler={kanbanCardUpdateHandler}
            moduleData={moduleData}
            access={permission}
            selectedValues={selectedValues}
            setIsImport={setIsImport}
            listViewHandle={handleListView}
            kanbanViewHandle={handleTableView}
            currentView={currentView}
            kanbanData={kanbanData}
            headerOptions={statusOptions}
            title="Deals"
            navigationRoute="/crm/Deals/"
            source={"deals"}
            dataColumn={kanbanColumn}
            tableCustomFields={
              kanbanData?.[0]?.fields?.filter(
                (field) => field?.isTableField === true
              ) || []
            }
            handleSearchChange={handleSearchChange}
            searchbox={searchbox}
            setSearchbox={setSearchbox}
            finalSearchedData={finalSearchedData}
            setFinalSearchedData={setFinalSearchedData}
            onOpen={() =>
              navigate(`/crm/${title}/create`, {
                state: { module: moduleData },
              })
            }
          />
        )}
      </Grid>
      {isOpen && (
        <Add
          isOpen={isOpen}
          title={title}
          size={size}
          moduleData={moduleData}
          onClose={onClose}
          setAction={setAction}
          action={action}
        />
      )}
      {deleteModel && (
        <CommonDeleteModel
          isOpen={deleteModel}
          onClose={() => closeDeleteModal()}
          type={
            menuSelectedDeleteItem.length > 0
              ? singularizeLastWord(title)
              : selectedValues && selectedValues.length > 1
                ? pluralizeLastWord(singularizeLastWord(title))
                : singularizeLastWord(title)
          }
          handleDeleteData={handleDelete}
          ids={selectedValues}
          selectedValues={moduleData?._id}
        />
      )}

      {edit && (
        <Edit
          isOpen={edit}
          title={title}
          size={size}
          moduleData={moduleData}
          selectedId={selectedId}
          setSelectedId={setSelectedId}
          onClose={setEdit}
          setAction={setAction}
          moduleId={moduleData?._id}
        />
      )}
    </div>
  );
};

export default Index;
